import React from 'react';
import { withConfig } from '@catalogo/core-connect/config';
import { B2WMessage, B2WDeliveryMessage, SellerDeliveryMessage } from './components';
import { ISoldAndDelivered } from './interfaces';

export const LINK_KNOW_MORE = 'https://www.americanas.com.br/hotsite/duvidas-marketplace?chave=footeracom_marketplace';

export const SoldAndDelivered: React.FC<ISoldAndDelivered> = ({ config, currentSku, isDigital }) => {
  const mainOffer = currentSku?.offers?.result?.[0];

  if (!mainOffer) {
    return null;
  }

  const { seller, b2wEntregas: hasB2wDelivery } = mainOffer;
  const { sellerId, shortName: brandName } = config;
  const isB2WSeller = seller.id === sellerId;
  const isO2O = seller?.id === '33014556000196';

  if (isB2WSeller || isO2O) {
    return <B2WMessage brandName={brandName} />;
  }

  if (hasB2wDelivery) {
    return <B2WDeliveryMessage seller={seller} brandName={brandName} linkKnowMore={LINK_KNOW_MORE} />;
  }

  return (
    <SellerDeliveryMessage seller={seller} brandName={brandName} linkKnowMore={LINK_KNOW_MORE} isDigital={isDigital} />
  );
};

export default withConfig(SoldAndDelivered);
